import axios from "../axios";

// Create a new order
export const createOrder = async (orderData) => {
  try {
    const response = await axios.post("/orders", orderData);
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message || "Failed to create order. Please try again.";
    throw new Error(message);
  }
};

// Get all orders for the authenticated user
export const getUserOrders = async () => {
  try {
    const response = await axios.get("/orders/my-orders");
    return response.data.orders;
  } catch (error) {
    const message =
      error.response?.data?.message || "Failed to fetch your orders.";
    throw new Error(message);
  }
};

// Get order by ID
export const getOrderById = async (orderId) => {
  try {
    const response = await axios.get(`/orders/${orderId}`);
    return response.data.data || response.data;
  } catch (error) {
    const message =
      error.response?.data?.message || "Failed to fetch order details.";
    throw new Error(message);
  }
};

// Update order status (Admin only)
export const updateOrderStatus = async (orderId, status) => {
  try {
    const response = await axios.put(`/orders/${orderId}/status`, { status });
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message || "Failed to update order status.";
    throw new Error(message);
  }
};

// Get all orders (Admin only)
export const getAllOrders = async () => {
  try {
    const response = await axios.get("/orders/all-orders");
    // Handle new API response structure
    if (response.data.success && response.data.data) {
      return response.data.data || [];
    }
    // Fallback for old API structure
    return response.data.orders || [];
  } catch (error) {
    const message =
      error.response?.data?.message || "Failed to fetch all orders.";
    throw new Error(message);
  }
};

// Get total orders count (Admin only)
export const getTotalOrders = async () => {
  try {
    const response = await axios.get("/orders/total");
    return response.data.totalOrders;
  } catch (error) {
    const message =
      error.response?.data?.error?.message || "Failed to fetch total orders count.";
    throw new Error(message);
  }
};

// Get delivered orders (Admin only)
export const getDeliveredOrders = async () => {
  try {
    const response = await axios.get("/orders/delivered");
    return response.data.deliveredOrders;
  } catch (error) {
    const message =
      error.response?.data?.message || "Failed to fetch delivered orders.";
    throw new Error(message);
  }
};

// Get total delivered orders count (Admin only)
export const getTotalDeliveredOrders = async () => {
  try {
    const response = await axios.get("/orders/delivered/total");
    return response.data.totalDelivered;
  } catch (error) {
    const message =
      error.response?.data?.message || "Failed to fetch total delivered orders count.";
    throw new Error(message);
  }
};

// Cancel an order
export const cancelOrder = async (orderId) => {
  try {
    const response = await axios.put(`/orders/cancel/${orderId}`);
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message || "Failed to cancel order.";
    throw new Error(message);
  }
};

// Reorder items from a previous order
export const reorderItems = async (orderId, reorderData) => {
  try {
    const response = await axios.post(`/orders/reorder/${orderId}`, reorderData);
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message || "Failed to reorder items.";
    throw new Error(message);
  }
};

// Request return for an order
export const requestReturn = async (orderId, returnData, images) => {
  try {
    const formData = new FormData();
    
    // Add text fields
    formData.append("reason", returnData.reason || "");
    if (returnData.itemsToReturn && Array.isArray(returnData.itemsToReturn)) {
      formData.append("itemsToReturn", JSON.stringify(returnData.itemsToReturn));
    }
    
    // Add image files
    if (images && Array.isArray(images)) {
      images.forEach((file) => {
        formData.append("images", file);
      });
    }
    
    const response = await axios.post(`/orders/return/${orderId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message || "Failed to submit return request.";
    throw new Error(message);
  }
};

